import { Model } from '@vuex-orm/core';

export class CompanyType extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'company_types';

  static primaryKey = 'code';

  static fields() {
    return {
      code: this.attr(null),
      name: this.attr(null),
    };
  }
}

export default CompanyType;
